/* tslint:disable */
// @ts-nocheck
/* eslint-disable */
/**
 * Rana simulation API
 * Rana simulation API (latest stable version: v3)   Framework release: 3.5.63   Rana simulation core release: 3.7.3   deployed on:  08:32AM (UTC) on September 25, 2026
 *
 * The version of the OpenAPI document: v3
 * Contact: info@nelen-schuurmans.nl
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { ContentTypeEnum } from "./ContentTypeEnum";
import {
  ContentTypeEnumFromJSON,
  ContentTypeEnumFromJSONTyped,
  ContentTypeEnumToJSON,
  ContentTypeEnumToJSONTyped,
} from "./ContentTypeEnum";
import type { EventStateEnum } from "./EventStateEnum";
import {
  EventStateEnumFromJSON,
  EventStateEnumFromJSONTyped,
  EventStateEnumToJSON,
  EventStateEnumToJSONTyped,
} from "./EventStateEnum";

/**
 *
 * @export
 * @interface MeasureLocation
 */
export interface MeasureLocation {
  /**
   *
   */
  readonly id?: number;
  /**
   *
   */
  weight: string;
  /**
   * e.g.
   *
   * * `v2_connection_node` - v2_connection_node
   * * `v2_pipe` - v2_pipe
   * * `v2_orifice` - v2_orifice
   * * `v2_culvert` - v2_culvert
   * * `v2_channel` - v2_channel
   * * `v2_weir` - v2_weir
   */
  contentType: ContentTypeEnum;
  /**
   *
   */
  contentPk: number;
  /**
   *
   */
  gridId?: number | null;
  /**
   *
   */
  readonly state?: EventStateEnum;
  /**
   *
   */
  readonly stateDetail?: any | null;
}

/**
 * Check if a given object implements the MeasureLocation interface.
 */
export function instanceOfMeasureLocation(value: object): value is MeasureLocation {
  if (!("weight" in value) || value["weight"] === undefined) return false;
  if (
    (!("contentType" in (value as Record<string, any>)) &&
      !("content_type" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["contentType"] === undefined &&
      (value as Record<string, any>)["content_type"] === undefined)
  )
    return false;
  if (
    (!("contentPk" in (value as Record<string, any>)) &&
      !("content_pk" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["contentPk"] === undefined &&
      (value as Record<string, any>)["content_pk"] === undefined)
  )
    return false;
  return true;
}

export function MeasureLocationFromJSON(json: any): MeasureLocation {
  return MeasureLocationFromJSONTyped(json, false);
}

export function MeasureLocationFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): MeasureLocation {
  if (json == null) {
    return json;
  }
  return {
    id: json["id"] == null ? undefined : json["id"],
    weight: json["weight"],
    contentType: ContentTypeEnumFromJSON(json["content_type"]),
    contentPk: json["content_pk"],
    gridId:
      json["grid_id"] === undefined ? undefined : json["grid_id"] === null ? null : json["grid_id"],
    state: json["state"] == null ? undefined : EventStateEnumFromJSON(json["state"]),
    stateDetail:
      json["state_detail"] === undefined
        ? undefined
        : json["state_detail"] === null
        ? null
        : json["state_detail"],
  };
}

export function MeasureLocationToJSON(json: any): MeasureLocation {
  return MeasureLocationToJSONTyped(json, false);
}

export function MeasureLocationToJSONTyped(
  value?: Omit<MeasureLocation, "id" | "state" | "stateDetail"> | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    weight: value["weight"],
    content_type: ContentTypeEnumToJSON(value["contentType"]),
    content_pk: value["contentPk"],
    grid_id: value["gridId"],
  };
}
